export const SubPageHeaderTexts = {
  Save: 'Salvar',
  Test: 'Testar o bot',
};
